module.exports = __webpack_public_path__ + "static/img/qcsh1.e8f5015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qcsh1.jpg
// module id = 4U5b
// module chunks = 0